import * as React from 'react'
import { FetchProspectVirtualTourQuery } from '../../../common/src/types.gen'
import DailyFrame from './DailyFrame'

interface ProspectVirtualTourProps {
  virtualTour: NonNullable<FetchProspectVirtualTourQuery['prospectVirtualTour']>
}

const ProspectVirtualTour = (props: ProspectVirtualTourProps) => {
  const { virtualTour } = props
  const { dailyCallOptions } = virtualTour
  return <DailyFrame dailyCallOptions={dailyCallOptions} />
}

export default ProspectVirtualTour
